<template>
	<v-container grid-list-md class="pa-0">
		<v-toolbar class="mb-3" color="secondary" dark dense tile>
			<v-toolbar-items>
				<Link
					v-for="(item, index) in items"
					:key="index"
					as="v-btn"
					text
					:href="
						$route(
							'tenant.reservations.' + item.route,
							$page.props.tenant.id
						)
					"
					:input-value="
						$route().current('tenant.reservations.' + item.route)
					"
				>
					<v-badge
						:content="item.value"
						:value="item.show && item.value > 0"
						color="red"
						overlap
						offset-x="10"
						offset-y="-10"
					>
						{{ item.text }}
					</v-badge>
				</Link>
			</v-toolbar-items>
			<v-spacer></v-spacer>
			<v-toolbar-items>
				<Link
					as="v-btn"
					text
					:href="
						$route(
							'tenant.reservation_availability.index',
							$page.props.tenant.id
						)
					"
					:input-value="
						$route().current('tenant.reservation_availability.*')
					"
				>
					<v-icon left>mdi-timer</v-icon>
					{{ $t("label.availability") }}
				</Link>
				<Link
					as="v-btn"
					text
					:href="
						$route(
							'tenant.reservation_sessions.index',
							$page.props.tenant.id
						)
					"
					:input-value="
						$route().current('tenant.reservation_sessions.*')
					"
				>
					<v-icon left>mdi-timer</v-icon>
					{{ $t("label.sessions") }}
				</Link>
				<Link
					as="v-btn"
					text
					:href="
						$route(
							'tenant.reservation_shifts.index',
							$page.props.tenant.id
						)
					"
					:input-value="
						$route().current('tenant.reservation_shifts.*')
					"
				>
					<v-icon left>mdi-timer</v-icon>
					{{ $t("label.shifts") }}
				</Link>
				<!-- <Link
					as="v-btn"
					text
					:href="
						$route(
							'tenant.reservation_report.index',
							$page.props.tenant.id
						)
					"
					:input-value="
						$route().current('tenant.reservation_report.*')
					"
				>
					<v-icon left>mdi-chart-timeline-variant</v-icon>
					{{ $t("label.report") }}
				</Link> -->
			</v-toolbar-items>
		</v-toolbar>
		<slot></slot>
	</v-container>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
export default {
	components: {
		Link,
	},
	data() {
		return {};
	},

	computed: {
		items() {
			return [
				{
					text: this.$t("label.all_reservations"),
					value: this.$page.props.reservation_statistic
						?.requested_count,
					route: "index",
					show: false,
				},
				// {
				// 	text: this.$t("label.pending"),
				// 	value: this.$page.props.reservation_statistic
				// 		?.pending_count,
				// 	route: "pending",
				// 	show: true,
				// },
				// {
				// 	text: this.$t("label.confirmed"),
				// 	value: this.$page.props.reservation_statistic
				// 		?.confirmed_count,
				// 	route: "confirmed",
				// 	show: true,
				// },
				// {
				// 	text: this.$t("label.completed"),
				// 	value: this.$page.props.reservation_statistic
				// 		?.completed_count,
				// 	route: "completed",
				// 	show: false,
				// },
				// {
				// 	text: this.$t("label.no_show"),
				// 	value: this.$page.props.reservation_statistic
				// 		?.no_show_count,
				// 	route: "no_show",
				// 	show: false,
				// },
				// {
				// 	text: this.$t("label.denied"),
				// 	value: this.$page.props.reservation_statistic?.denied_count,
				// 	route: "denied",
				// 	show: false,
				// },
				// {
				// 	text: this.$t("label.canceled"),
				// 	value: this.$page.props.reservation_statistic
				// 		?.canceled_count,
				// 	route: "canceled",
				// 	show: false,
				// },
			];
		},
	},
};
</script>